<template>
  <div>
    <create-vault
      class="flex flex-row"
      v-if="section == 1"
      :current-step="current_step"
      :current-sub-step="current_sub_step"
      :steps="steps"
      :static-side-nav="true"
      :show-global-link="true"
      v-model="form"
      :subscriptions="subscriptions"
      :payment-types="payment_types"
      :roles="roles"
      @go-to="goTo"
      @submit-data="submitData"
      @getSubscriptions="getSubscriptions"
    ></create-vault>

    <div
      v-if="vault_type == 'strata' && section == 2"
      class="bg-fireworks h-screen"
    >
      <div class="flex flex-row h-screen">
        <side-nav :static="true"></side-nav>

        <div
          class="flex flex-col justify-center items-center w-full"
          v-if="confirmed"
        >
          <div
            class="
              border
              flex flex-col
              justify-center
              items-center
              w-5/6
              sm:w-3/4
              md:w-1/2
              bg-white
              p-4
              sm:p-6
              shadow-lg
            "
          >
            <p
              class="
                text-2xl
                sm:text-4.25xl
                text-brand
                mt-8
                mb-8
                sm:pb-8
                text-center
              "
            >
              Congratulations, let's get started!
            </p>
            <p class="flex flex-col text-center text-grey-darker mt-8">
              <span class="text-lg">Your {{ vault_name }}</span>
              <span class="text-5xl py-6">{{ form.vault.name }}</span>
              <span class="text-lg">has been created</span>
            </p>
            <p class="flex flex-col text-center mb-8 text-grey-darker">
              <span>
                <i class="fa fa-spinner fa-spin fa-4x p-4"></i>
              </span>
              <span class="uppercase text-sm sm:text-lg">Redirecting...</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="vault_type == 'business' && section == 2"
      class="bg-orange h-screen"
    >
      <div class="flex flex-row h-screen">
        <side-nav :static="true"></side-nav>

        <div
          class="flex flex-col justify-center items-center w-full"
          v-if="confirmed"
        >
          <div
            class="
              border
              flex flex-col
              justify-center
              items-center
              w-5/6
              sm:w-3/4
              md:w-1/2
              bg-white
              p-4
              sm:p-6
              shadow-lg
            "
          >
            <p
              class="
                text-2xl
                sm:text-4.25xl
                text-brand
                mt-8
                mb-8
                sm:pb-8
                text-center
              "
            >
              Congratulations, let's get started!
            </p>
            <p class="flex flex-col text-center text-grey-darker mt-8">
              <span class="text-lg">Your {{ vault_name }}</span>
              <span class="text-5xl py-6">{{ form.vault.name }}</span>
              <span class="text-lg">has been created</span>
            </p>
            <p class="flex flex-col text-center mb-8 text-grey-darker">
              <span>
                <i class="fa fa-spinner fa-spin fa-4x p-4"></i>
              </span>
              <span class="uppercase text-sm sm:text-lg">Redirecting...</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <sweet-modal
      overlay-theme="dark"
      icon="success"
      ref="submit_data"
      hide-close-button
      blocking
    >
      <!-- signing up -->
      <div class="my-4" v-if="signing_up">
        <p class="text-3xl font-medium">Creating your Vault</p>
        <p class="text-grey-darker mt-4">
          <i class="fa fa-circle-notch fa-spin"></i> Please wait...
        </p>
      </div>
    </sweet-modal>

    <sweet-modal
      overlay-theme="dark"
      icon="error"
      ref="confirmation_error"
      @close="redirectToCreateVault"
    >
      <div v-if="confirmation_error != ''">
        <p class="font-medium">An Error occured upon creating your Vault</p>
        <p class="mt-4">
          Error {{ confirmation_error.code ? confirmation_error.code : "" }}:
          {{ confirmation_error.message }}
        </p>
      </div>
      <div v-else>
        <p class="font-medium">An Error Occured</p>
        <p class="mt-4">We apologize for the inconvenience</p>
      </div>
    </sweet-modal>

    <sweet-modal
      overlay-theme="dark"
      icon="warning"
      ref="check_auth"
      hide-close-button
      blocking
    >
      <p class="text-grey-darker mt-4">Please wait...</p>
    </sweet-modal>
  </div>
</template>

<script>
import CreateVault from "../components/Onboarding/CreateVault";
import { parseCardExpiry } from "../card_expiry.mjs";

export default {
  components: {
    CreateVault,
  },

  props: {
    payrix_url: {
      default: () => {
        return {};
      },
    },
    payrix_business_key: {
      default: () => {
        return {};
      },
    },
    vault_dashboard_url: {
      default: () => {
        return {};
      },
    },
    trial_days: {
      default: 30,
    },
    source_form: {
      default: () => {
        if (window.vault_type == "strata") {
          return {
            billing: {
              type: "",
              financial_institution: "",
              cycle_length: "monthly", // same with plan_cycle
              bsb: "",
              account_number: "",
              account_name: "",
              card_expiry: "", // MM/YYYY
              address: "",
              state: "",
              country: "AU", // Default
              city: "",
              postcode: "",
            },
            billing_invoice: {
              email: "",
              company_name: "",
              address: "",
              suburb: "",
              state: "",
              postcode: "",
            },
            vault: {
              name: "",
              strata_plan_number: "",
              number_of_lots: "",
              address: "",
              building_type: "",
              suburb: "",
              state: "",
              postcode: "",
            },
            plan: "",
            role: "",
            buy: 1,
            plan_cycle: "monthly", // same with billing.cycle_length
          };
        }
        if (window.vault_type == "business") {
          return {
            billing: {
              type: "",
              financial_institution: "",
              cycle_length: "monthly", // same with plan_cycle
              bsb: "",
              account_number: "",
              account_name: "",
              card_expiry: "", // MM/YYYY
              address: "",
              state: "",
              country: "", // Default
              city: "",
              postcode: "",
            },
            billing_invoice: {
              email: "",
              company_name: "",
              address: "",
              suburb: "",
              state: "",
              postcode: "",
            },
            vault: {
              name: "",
              strata_plan_number: "",
              number_of_lots: "",
              address: "",
              building_type: "",
              suburb: "",
              state: "",
              postcode: "",
            },
            plan: "",
            role: "",
            buy: 1,
            plan_cycle: "monthly", // same with billing.cycle_length
          };
        }
      },
    },

    // default items
    steps: {
      default: () => {
        if (window.vault_type == "strata") {
          return {
            1: {
              short_name: "Property",
              long_name: "Property Details",
              template: "property-details",
            },
            2: {
              short_name: "Select Subscription",
              long_name: "Select Subscription",
              template: "select-subscription",
            },
            3: {
              short_name: "Billing",
              long_name: "Billing",
              template: "billing-details",
            },
            4: {
              short_name: "Finish",
              long_name: "Finish",
              template: "FinishAddVault",
            },
          };
        }

        if (window.vault_type == "business") {
          return {
            1: {
              short_name: "Vault Details",
              long_name: "Vault Details",
              template: "vault-details",
            },
            2: {
              short_name: "Select Subscription",
              long_name: "Select Subscription",
              template: "select-subscription",
            },
            3: {
              short_name: "Billing",
              long_name: "Billing",
              template: "business-billing-details",
            },
            4: {
              short_name: "Finish",
              long_name: "Finish",
              template: "business-finish-add-vault",
            },
          };
        }
      },
    },
    roles: {
      default: () => {
        return {
          "strata-manager": {
            key: "strata-manager",
            display: "Strata Manager",
          },
          "owners-corp": {
            key: "owners-corp",
            display: "Owner's Corp",
          },
          "lot-owner": {
            key: "lot-owner",
            display: "Lot Owner",
          },
          "building-manager": {
            key: "building-manager",
            display: "Building Manager",
          },
          tenant: {
            key: "tenant",
            display: "Tenant",
          },
          developer: {
            key: "developer",
            display: "Developer",
          },
        };
      },
    },
    payment_types: {
      default: () => {
        return {
          "direct-debit": {
            key: "direct-debit",
            name: "Direct Debit",
          },
          "credit-card": {
            key: "credit-card",
            name: "Credit Card",
          },
        };
      },
    },
    error_codes: {
      default: () => {
        return {
          "006": {
            code: "006",
            message: "Invalid Expiry Date",
          },
          "007": {
            code: "007",
            message: "Invalid Card Number",
          },
          "031": {
            code: "031",
            message: "Invalid BSB",
          },
          "032": {
            code: "032",
            message: "Invalid Account Number",
          },
        };
      },
    },
  },

  data() {
    return {
      form: {},
      section: 1,
      current_step: 1,
      current_sub_step: 1,

      signing_up: false,
      confirmed: false,

      confirmation_error: "",

      subscriptions: {},
    };
  },

  created() {
    this.csrf = Laravel.csrfToken;
    this.form = this.source_form;
  },

  mounted() {
    this.$refs.check_auth.open();
    // check if user is authenticated
    axios.get("/api/login").then(({ data }) => {
      if (_.isEmpty(data)) {
        window.location.href = "/";
      }

      this.$refs.check_auth.close();
    });

    this.getSubscriptions();
  },

  methods: {
    redirectToCreateVault() {
      window.location.href = "/add-vault";
    },
    updateForm(payload) {
      this.form = payload.form;
    },
    submitData(payload) {
      this.$refs.submit_data.open();
      this.form = payload.form;
      // remove spaces
      this.form.billing.account_number =
        this.form.billing.account_number.replace(/\s+/g, "");
      if (!_.isNil(payload.form.vault.state.code)) {
        this.form.vault.state = payload.form.vault.state.code;
      }

      // handle BV
      if (!_.isNil(this.form.billing.country)) {
        if (this.form.billing.country == "New Zealand") {
          this.form.billing.country = "NZ";
          this.form.vault.state = this.form.billing.state;
          this.form.billing.state = "";
        }
        if (this.form.billing.country == "Australia") {
          this.form.billing.country = "AU";
        }
      }

      this.signing_up = true;
      this.confirm();
    },
    async confirm() {
      if (this.form.billing.type == "credit-card") {
        try {
          const billingCopy = { ...this.form.billing };

          this.form.billing.account_number = "";
          this.form.billing.account_name = "";
          this.form.billing.card_expiry = "";
          this.form.billing.ccv = "";

          const response = await this.tokenizeCard(billingCopy);

          const { token } = response;

          this.form.card_token = token;

          const { account_number, account_name, card_expiry, ccv, ...billing } =
            this.form.billing;

          this.form.billing = {
            ...billing,
          };
        } catch (error) {
          if (error && error.response) {
            const { data } = error.response;

            this.section = 1;
            this.current_step = 5;

            this.$refs.submit_data.close();

            this.confirmation_error = {
              message: data.errorMessage,
            };
            this.$refs.confirmation_error.open();
          }
        }
      }

      this.section = 2;
      axios
        .post("/api/vaults/create", this.form)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            this.signing_up = false;
            this.$refs.submit_data.close();
            this.tryLogin();
          } else {
            this.section = 1;
            this.current_step = 5;
            this.confirmation_error = "";
            this.$refs.submit_data.close();

            let regex = /- \s*(\d*)\s*:Field/g;
            let error_code = regex.exec(result.message);

            if (error_code != null) {
              let err = this.error_codes[error_code[1]];
              if (err) {
                this.confirmation_error = err;
              }
            } else {
              this.confirmation_error = {
                message: result.message,
              };
            }
            this.$refs.confirmation_error.open();
          }
        })
        .catch((error) => {
          this.section = 1;
          this.current_step = 5;
          this.$refs.submit_data.close();
          this.confirmation_error = "";
          let data = error.response.data;
          if (data != "") {
            this.$refs.submit_data.close();
            let regex = /- \s*(\d*)\s*:Field/g;
            let error_code = regex.exec(data.message);

            if (error_code != null) {
              let err = this.error_codes[error_code[1]];
              if (err) {
                this.confirmation_error = err;
              }
            }
            this.$refs.confirmation_error.open();
          }
        });
    },
    async tokenizeCard(billing) {
      const url = `${this.payrix_url}/businesses/${this.payrix_business_key}/services/tokenize-card`;
      const { month, year } = parseCardExpiry(billing.card_expiry);
      const response = await axios.post(url, {
        Card: {
          CardholderName: billing.account_name,
          CardNumber: billing.account_number,
          Ccv: billing.ccv,
          ExpiryMonth: month,
          ExpiryYear: year,
        },
      });
      return await response.data;
    },
    goTo(payload) {
      this.section =
        payload.next_section != undefined ? payload.next_section : 1;
      this.current_step =
        payload.next_step != undefined ? payload.next_step : 1;
      this.current_sub_step =
        payload.next_sub_step != undefined ? payload.next_sub_step : 1;
    },
    tryLogin() {
      this.confirmed = true;
      setTimeout(function () {
        window.location.href = "/#/vaults";
      }, 2000);
    },
    getSubscriptions(payload) {
      const params = {
        'country': payload == 'NZ' ? 'NZ' : 'AU',
      };

      axios.get("api/register/show-plans", {
        params: params,
      }).then(({ data }) => {
        let plans = {};
        _.each(data, (plan) => {
          _.set(plans, `${plan.name}.${plan.interval}`, plan);
        });
        this.subscriptions = plans;
      });
    },
  },

  computed: {
    vault_name() {
      return _.startCase(window.vault_type) + " Vault";
    },
    vault_type() {
      return window.vault_type;
    },
  },
};
</script>

<style scoped>
.bg-vault {
  background-image: url("/images/vault.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
.bg-fireworks {
  background-image: url("/images/fireworks.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
